import { render, staticRenderFns } from "./NotificationManagelist.vue?vue&type=template&id=d5717fea&scoped=true&"
import script from "./NotificationManagelist.vue?vue&type=script&lang=js&"
export * from "./NotificationManagelist.vue?vue&type=script&lang=js&"
import style0 from "./NotificationManagelist.vue?vue&type=style&index=0&id=d5717fea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5717fea",
  null
  
)

export default component.exports